export default (props, vars) => !props?.['companyLogo'] && 'no-image';
